
define('text!features/overlayGameLauncher/stats/gems/gemsViewSmall.html',[],function () { return '<div>\n    <span class="icon icon-24 icons-diamond"></span> {{gems}}\n</div>\n';});

